import React from 'react';
import { Link } from 'react-router-dom';

const ProductFooter = () => {
  return (
    <footer
      className="text-muted"
      style={{
        margin: '0 auto',
        backgroundColor: '#fff',
        fontSize: '0.9rem',
        lineHeight: '1.8',
        padding: '0px 0px 0px',
        marginBottom: '60px'
      }}
    >
      <div className="footer-wrapper">
        <div className="ptg__footer__company__container">
          <div className="ptg__footer__company__wrapper">
            <div className="ptg__footer__company__wrapper centered">
              <span className="ptg__footer__company-info">
                <Link to="/join/agreement">이용약관</Link> |{' '}
                <Link to="/join/jungbo">개인정보처리방침</Link>
              </span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info"><strong>네리네</strong></span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info" style={{ whiteSpace: 'nowrap' }}>전북특별자치도 전주시 덕진구 작은모래내3길 31, 1층</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">대표번호 : 063-246-0173</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">대표 : 임미성</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">개인정보보호책임자 : 임미성</span>
              <span className="division"> </span>
              <br />
              <span className="ptg__footer__company-info">사업자등록번호 : 383-34-01743</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">통신판매업신고 : 제2026-전주덕진-0480호</span>
              <span className="division"> </span>
              <span className="ptg__footer__company-info">
                <a href="mailto:nerine12@daum.net">nerine12@daum.net</a>
              </span>
            </div>

            <div className="mt-2">
              <span className="ptg__footer__company-info">
                &copy; 2026 NERINE, Inc. All Rights Reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ProductFooter;
